import logoSrc from "src/assets/logos/douyin.png?no-inline";

export const DouyinLogo = (props: React.SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <image href={logoSrc} width="24" height="24" />
    </svg>
  );
};
